import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import styles from './dropdown-content.scss?inline';
import { ref, createRef } from 'lit/directives/ref.js';
import { setPositionRelativeElement } from '@/helpers';

export default class SotbitDropdownContent extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        useTeleport: { type: Boolean, attribute: 'use-teleport' },
        variant: { type: String },
        disableAutoHide: { type: Boolean, attribute: 'disable-auto-hide' },
    };

    constructor() {
        super();

        this.useTeleport = false;
        this.variant = null;
        this._dropdown = null;
        this._relativeElement = null;
        this._scrollPanelRef = createRef();
        this.disableAutoHide = false;
    }

    connectedCallback() {
        super.connectedCallback();

        this._setPosition();
        document.addEventListener('scroll', this._scrollHandler, {
            passive: true,
        });
        window.addEventListener('scroll', this._scrollHandler, {
            passive: true,
        });

        this.setAttribute('connected', '');
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('scroll', this._scrollHandler);
        window.removeEventListener('scroll', this._scrollHandler);

        this.removeAttribute('connected', '');
    }

    getDropdown() {
        return this._dropdown;
    }

    setDropdown(dropdown) {
        this._dropdown = dropdown;
    }

    getRelativeElement() {
        return this._relativeElement;
    }

    setRelativeElement(relativeElement) {
        this._relativeElement = relativeElement;
    }

    _setPosition() {
        if (!this.useTeleport) {
            return;
        }

        setPositionRelativeElement(this, this._relativeElement || this._dropdown);
    }

    _scrollHandler = (e) => {
        if (this.disableAutoHide) {
            return;
        }

        if (!this._scrollPanelRef?.value) {
            return;
        }

        if (
            e.target === document ||
            (!e.composedPath()?.includes(this._scrollPanelRef?.value) &&
                !e.composedPath()?.includes(this) &&
                !e.detail?.originalEvent?.composedPath()?.includes(this) &&
                !e.detail?.originalEvent?.composedPath()?.includes(this._scrollPanelRef?.value))
        ) {
            this._dropdown?.hide();
        }
    };

    _handleSlotChange = (e) => {
        if (!this.useTeleport) {
            return;
        }

        this._dropdown._dropdownItems = e.target.assignedNodes({ flatten: true });
    };

    render() {
        return html`
        <div class="scroll-wrapper">
            <sotbit-scroll-panel
                class="scroll-panel"
                part="scroll-panel"
                dropdown-variant="${this.variant || nothing}"
                variant="dropdown"
                ${ref(this._scrollPanelRef)}
            >
                <div class="content">
                    <slot @slotchange="${this._handleSlotChange}"></slot>
                </div>
            </sotbit-scroll-panel>
        </div>
        <slot name="footer"></slot>
        `;
    }
}
